export const MuiInputAdornment = palette => ({
  styleOverrides: {
    root: {
      '& > .MuiIconButton-root': {
        color: palette.surface.onSurface
      }
    }
  }
})
